<card-expanding
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <div header-title class="gap-6x">
    <span>{{title | translate}}</span>
    <span class="badge-new mt-1"> {{'common.new' | translate}} </span>
  </div>

  <div header-actions *ngIf="productCard.isOwnProduct">
    <ng-container *requiredRights="[UserAction.ManageProductStoreSchemes]">
      <div
        *ngIf="canEditStoreSchemes"
        [ngxTippy]="
          'cards.products.product_store_schemes.tooltip.add_requires_pricelist'
            | translate
        "
        [tippyClassName]="hasAnyBasePricelistPrice ? 'hidden' : 'tippy-white'"
        [tippyProps]="{ placement: 'left' }"
      >
        <lxm-button
          type="beige"
          icon="plus-dark"
          label="cards.products.product_store_schemes.action.add_schema"
          (click)="openBaseSchemaDialog()"
          [disabled]="!hasAnyBasePricelistPrice"
        >
        </lxm-button>
      </div>
    </ng-container>
  </div>

  <div body>
    <div *ngIf="!storeSchemes?.length">
      <no-content
        image="no-product-catalog"
        text="cards.products.product_store_schemes.no_content.text"
        [inline]="true"
      ></no-content>
    </div>

    <div class="row overflow-x" *ngIf="storeSchemes?.length">
      <div class="col-12 no-padding">
        <mat-table
          [dataSource]="storeSchemes"
          matSort
          [@.disabled]="true"
          [class.market-product]="!isOwnProduct"
        >
          <!-- Validity Column -->
          <ng-container matColumnDef="valid">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'cards.products.product_store_schemes.table.valid' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span
                >{{row.validFrom | formDate}} - {{row.validTo | formDate}}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Visibility -->
          <ng-container matColumnDef="visibility">
            <mat-header-cell *matHeaderCellDef>
              <div
                class="w-full"
                [innerHTML]="'cards.products.product_store_schemes.table.visible_in_store' | translate"
              ></div>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              [ngSwitch]="row.retailersListIsExclusive"
            >
              <div class="flex flex-col">
                <ng-container *ngSwitchCase="false">
                  {{ 'common.to_nobody' | translate }}
                  <ng-container *ngIf="row.retailerIds?.length">
                    {{ 'common.except_selected_clients_suffix' | translate }}:
                    <br />
                    <div class="comma-delimited-list">
                      <span *ngFor="let retailerId of row.retailerIds">
                        {{ retailChainsById[retailerId]?.name }}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="true">
                  {{ 'common.to_everyone' | translate }}
                  <ng-container *ngIf="row.retailerIds?.length">
                    {{ 'common.except_selected_clients_suffix' | translate }}:
                    <br />
                    <div class="comma-delimited-list">
                      <span *ngFor="let retailerId of row.retailerIds">
                        {{ retailChainsById[retailerId]?.name }}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Category -->
          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef>
              <div
                class="w-full"
                [innerHTML]="'cards.products.product_store_schemes.table.store_category' | translate"
              ></div>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div>{{row.storeCategoryName}}</div>
            </mat-cell>
          </ng-container>

          <!-- User Column -->
          <ng-container matColumnDef="user">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'table.user' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <user [name]="row.modifiedBy"></user>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
          <mat-row
            class="assortment-table-row"
            [class.table-row-hover]="canEdit && row?.isEditable"
            [class.current]="row?.isCurrent"
            [class.upcoming]="row?.isEditable"
            [class.expired]="!row.isCurrent && !row.isEditable"
            *matRowDef="let row; columns: columns;"
            (click)="openBaseSchemaDialog(row)"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</card-expanding>
